// @core/api/endpoints/calendar/get_recurring_event_instances.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListEventsResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * List recurring event instances
 * Expands a recurring event series into individual instances within the specified date range, including any exceptions (modified/deleted occurrences).
 */
export async function GetRecurringEventInstances(
  event_id: string,
  params?: {
    time_max?: string | number | boolean;
    time_min?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListEventsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/events/:event_id/instances`;
  requestPath = requestPath.replace(':event_id', encodeURIComponent(event_id));
  const requestOptions = options;
  return client.get<ListEventsResponse>(requestPath, { ...requestOptions, params });
}
